module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/axios/index.js
// module id = 186
// module chunks = 0